export default "__VITE_ASSET__I_iyJ_I$__"